const BASE_SERVER_PATH = 'https://rxqu50dn1e.execute-api.ap-southeast-1.amazonaws.com/prod/api'
// const BASE_SERVER_PATH = 'http://localhost:8000/api'

export default {
  BASE_SERVER_PATH: BASE_SERVER_PATH
}
